import React, { useEffect, useState } from "react";

const SPLASH_VISIBLE_MS = 1900;
const SPLASH_EXIT_MS = 420;

const styles = {
  screen: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "100dvh",
    backgroundColor: "#ffffff",
    color: "#070b14",
    fontFamily: "Arial, Helvetica, sans-serif",
    overflow: "hidden",
  },
  brand: {
    width: "100%",
    maxWidth: "19rem",
    padding: "2rem",
    textAlign: "center",
  },
  monogram: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "clamp(4rem, 18vw, 5.2rem)",
    marginBottom: "clamp(0.7rem, 2dvh, 1rem)",
    color: "#bd8732",
    fontFamily: "Bodoni MT, Didot, Georgia, serif",
    fontSize: "clamp(4.4rem, 19vw, 5.8rem)",
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: 0.7,
  },
  monogramLetter: {
    display: "inline-block",
  },
  monogramSecondLetter: {
    marginLeft: "-0.13em",
  },
  wordmark: {
    margin: 0,
    color: "#050a15",
    fontFamily: "Bodoni MT, Didot, Georgia, serif",
    fontSize: "clamp(1.7rem, 7.8vw, 2.2rem)",
    fontWeight: 400,
    letterSpacing: "0.11em",
    lineHeight: 1,
    whiteSpace: "nowrap",
  },
};

function SplashScreen({ children, headingTag = "h1" }) {
  const [isComplete, setIsComplete] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const BrandHeading = headingTag;

  useEffect(() => {
    const exitTimeoutId = window.setTimeout(() => setIsExiting(true), SPLASH_VISIBLE_MS);
    const completeTimeoutId = window.setTimeout(
      () => setIsComplete(true),
      SPLASH_VISIBLE_MS + SPLASH_EXIT_MS
    );

    return () => {
      window.clearTimeout(exitTimeoutId);
      window.clearTimeout(completeTimeoutId);
    };
  }, []);

  if (isComplete) {
    return children;
  }

  return (
    <main
      className={`mobile-splash-screen${isExiting ? " is-exiting" : ""}`}
      data-mobile-screen="splash"
      style={styles.screen}
      aria-label="Jet Black"
    >
      <style>
        {`
          .mobile-splash-screen.is-exiting {
            animation: mobileSplashExit 420ms ease both;
          }

          .mobile-splash-brand {
            position: relative;
          }

          .mobile-splash-monogram {
            opacity: 0;
            transform: scale(0.92);
            animation: mobileSplashMonogram 900ms cubic-bezier(0.22, 1, 0.36, 1) 110ms forwards;
            will-change: opacity, transform;
          }

          .mobile-splash-wordmark {
            opacity: 0;
            animation: mobileSplashWordmark 720ms ease 780ms forwards;
            will-change: opacity;
          }

          @keyframes mobileSplashMonogram {
            to {
              opacity: 1;
              transform: scale(1);
            }
          }

          @keyframes mobileSplashWordmark {
            to {
              opacity: 1;
            }
          }

          @keyframes mobileSplashExit {
            to {
              opacity: 0;
              transform: translateY(-0.35rem);
            }
          }

          @media (prefers-reduced-motion: reduce) {
            .mobile-splash-screen,
            .mobile-splash-screen.is-exiting,
            .mobile-splash-monogram,
            .mobile-splash-wordmark {
              animation-duration: 1ms;
              animation-delay: 0ms;
            }
          }
        `}
      </style>
      <section className="mobile-splash-brand" style={styles.brand}>
        <div className="mobile-splash-monogram" style={styles.monogram} aria-hidden="true">
          <span style={styles.monogramLetter}>J</span>
          <span style={{ ...styles.monogramLetter, ...styles.monogramSecondLetter }}>B</span>
        </div>
        <BrandHeading className="mobile-splash-wordmark" style={styles.wordmark}>JET BLACK</BrandHeading>
      </section>
    </main>
  );
}

export default SplashScreen;
